export const normalizePhoneNumber = phone => {
  let digits = phone.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }

  if (digits.length === 10) {
    return `+1${digits}`;
  }

  if (digits.length > 11) {
    return `+${digits}`;
  }
  return null;
};
